// TODO: implement booking page wrapper
export default function BookingPage() {
  return <div>Booking Page</div>
}
